import React, { useEffect } from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		background: theme.mode === "light" ? "rgba(255,255,255,.86)" : "rgba(16,28,52,.82)",
		flex: "none",
		borderBottom: `1px solid ${theme.palette.divider}`,
		height: "68px",
		backdropFilter: "blur(10px)",
		WebkitBackdropFilter: "blur(10px)",
		boxShadow: theme.mode === "light" ? "0 8px 18px rgba(8,16,34,.08)" : "0 10px 20px rgba(0,0,0,.24)",
		[theme.breakpoints.down("sm")]: {
			flexWrap: "wrap",
			height: 'max-content'
		},
	},
	backButton: {
		margin: 8,
		borderRadius: 12,
		minWidth: 38,
		height: 40,
		border: `1px solid ${theme.palette.divider}`,
		background: theme.mode === "light" ? "rgba(255,255,255,.92)" : "rgba(21,34,62,.86)",
		"&:hover": {
			background: theme.mode === "light" ? "rgba(255,255,255,1)" : "rgba(28,44,80,.94)",
		},
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
				>
					<Button className={classes.backButton} color="primary" onClick={handleBack}>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
